import React from 'react';
import { Link } from 'react-router-dom';
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import Navbar from '../components/Navbar';

const Cores = () => {
  // Lista pré-definida de cores com seus slugs e nomes amigáveis
  const coresPreDefinidas = [
    { slug: 'atari2600', name: 'Atari 2600' },
    { slug: 'gb', name: 'Game Boy' },
    { slug: 'gbc', name: 'Game Boy Color' },
    { slug: 'n64', name: 'Nintendo 64' },
    { slug: 'nes', name: 'Nintendo' },
    { slug: 'psx', name: 'Playstation' },
    { slug: 'segaMS', name: 'Sega Master System' },
    { slug: 'snes', name: 'Super Nintendo' },
    // Adicione outros cores conforme necessário
  ];

  return (
    <>
      <Box sx={{ pb: 14 }}>
        <Box sx={{ width: '100%' }}>
          <Typography variant="h4" gutterBottom sx={{ mt: 2, px: 2 }}>
            Cores
          </Typography>
          <List sx={{ width: '100%' }}>
            {coresPreDefinidas.map((core) => (
              <ListItem key={core.slug} disablePadding>
                <ListItemButton
                  component={Link}
                  to={`/${core.slug}`}
                  sx={{
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.08)',
                    },
                    mb: 1,
                    textDecoration: 'none',
                    color: 'inherit',
                  }}
                >
                  <ListItemText
                    primary={core.name}
                    primaryTypographyProps={{
                      variant: 'h6',
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
      <Navbar />
    </>
  );
};

export default Cores;